import type { ClinicalAssignmentRule } from "@/types/clinician";

// Active System Labs rules with no products: routing needs exactly one. The
// storefront rule (channel "storefront") also lists no products but only
// routes rx-store storefront orders, so it never counts.
export function globalFallbackCount(rules: ClinicalAssignmentRule[]): number {
  return rules.filter(
    (rule) =>
      rule.active &&
      rule.product_ids.length === 0 &&
      (rule.channel ?? "all") === "all",
  ).length;
}
